﻿import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { VerifyFilesExistToDownload } from '../../../../api/sfd';
import { useUser } from '../../../../context/UserContext';
import { useQuery } from '@tanstack/react-query';
import Slide from '@mui/material/Slide';
import SnackbarContent from '@mui/material/SnackbarContent';
import DownloadIcon from '@mui/icons-material/Download';
import CancelIcon from '@mui/icons-material/Cancel';
import IconButton from '@mui/material/IconButton';
import Alert from '@mui/material/Alert';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import ArticleIcon from '@mui/icons-material/Article';
import { useNavigate } from 'react-router-dom';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import OutboundTwoToneIcon from '@mui/icons-material/OutboundTwoTone';
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
export default function SfuSnackbarNotification() {
  let routePrefix = 'Applications';
  const user = useUser();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const verifyFilesExist = useQuery({
    queryKey: ['VerifyFilesExist'],
    queryFn: () => VerifyFilesExistToDownload(user.npnID)(),
    enabled: user != null && !user.isHO,
  });

  useEffect(() => {
    if (verifyFilesExist.isSuccess && verifyFilesExist.data != null) {
      setOpen(verifyFilesExist.data > 0);
    }
  }, [verifyFilesExist.isSuccess, verifyFilesExist.data]);

  function SlideTransition(props) {
    return <Slide {...props} direction="down" />;
  }

  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={() => {
          setOpen(false);
        }}
      >
        <CancelIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        message="Hi there!"
        key={'top-center-sfu-snackbar'}
        action={action}
      >
        <Box
          style={{
            backgroundColor: 'orange',
            width: '22em',
            height: 'auto',
            borderRadius: '15px',
            boxShadow: '3px 3px 5px 6px #ccc',
            display: 'flex',
          }}
          onClick={() => {
            setOpen(false);
            navigate('/' + routePrefix + '/SecureFileDelivery');
          }}
        >
          <div
            style={{ padding: '0.75em 1em', color: 'white', fontSize: 'larger', fontWeight: '400' }}
          >
            You have files available for download
          </div>
          <div>
            <IconButton size="small" aria-label="close" color="inherit">
              <OutboundTwoToneIcon fontSize="large" style={{ width: '2em', height: 'auto' }} />
            </IconButton>
          </div>
        </Box>
      </Snackbar>
    </>
  );

  /*return (
        <>
         <Alert icon={<DownloadIcon fontSize="inherit" />} style={{ backgroundColor: 'orange' }} sx={{ width: '100%' }} onClose={() => { setOpen(false); }}>
                    Hi there! \n You have files to download
                </Alert>

            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={open}
                onClose={() => { setOpen(false) }}
                message="Hi there!"
                key={'top-center-sfu-snackbar'}
                slots={{ transition: SlideTransition }}
                action={action}
            >
                <SnackbarContent message="You have files to download">
                    <ChatBubbleOutlineIcon>
                        <DownloadIcon/>
                    </ChatBubbleOutlineIcon>
                </SnackbarContent>
            </Snackbar>
        </>
    );*/
}
